import { useContext } from "react";
import { CharityShopsContext } from "./CharityShops/CharityShops.context";
import type { CharityShopsContextState } from "./CharityShops/CharityShops.types";
import { CmsMapContext } from "./CmsMap/CmsMap.context";
import type { CmsMapContextState } from "./CmsMap/CmsMap.types";
import { FavouritesManagerContext } from "./FavouritesManager/FavouritesManager.context";
import { OurCentresContext } from "./OurCentres/OurCentres.context";
import type { OurCentresContextState } from "./OurCentres/OurCentres.types";
import { PageManagerContext } from "./PageManager/PageManager.context";
import type { PageManagerContextState } from "./PageManager/PageManager.provider";
import { SponsorDogsContext } from "./SponsorDogs/SponsorDogs.context";
import type { SponsorDogsContextState } from "./SponsorDogs/SponsorDogs.provider";
import { VolunteerVacanciesContext } from "./VolunteerVacancies/VolunteerVacancies.context";
import type { VolunteerVacanciesContextState } from "./VolunteerVacancies/VolunteerVacancies.provider";

import type { DogSearchContextState } from "./DogSearchApi/DogSearchApi.types";
import { DogSearchApiContext as DogSearchApiContextIE } from "./DogSearchApi/ie/DogSearchApi.context";
import { DogSearchApiContext as DogSearchApiContextUK } from "./DogSearchApi/uk/DogSearchApi.context";

import { MyAccountContext as MyAccountContextIE } from "./MyAccount/ie/MyAccount.context";
import type { MyAccountContextState as MyAccountContextStateIE } from "./MyAccount/ie/MyAccount.provider";
import { MyAccountContext as MyAccountContextUK } from "./MyAccount/uk/MyAccount.context";
import type { MyAccountContextState as MyAccountContextStateUK } from "./MyAccount/uk/MyAccount.provider";

export const useDogSearchApi = (): DogSearchContextState =>
	useContext(
		process.env.GATSBY_IS_IE === "true"
			? DogSearchApiContextIE
			: DogSearchApiContextUK,
	);

export const useOurCentres = (): OurCentresContextState =>
	useContext(OurCentresContext);

export const useCharityShops = (): CharityShopsContextState =>
	useContext(CharityShopsContext);

export const usePageManager = (): PageManagerContextState =>
	useContext(PageManagerContext);

export const useVolunteerVacancies = (): VolunteerVacanciesContextState =>
	useContext(VolunteerVacanciesContext);

export const useSponsorDogs = (): SponsorDogsContextState =>
	useContext(SponsorDogsContext);

export const useFavouritesManager = (): FavouritesManagerContext =>
	useContext(FavouritesManagerContext);

export const useCmsMap = (): CmsMapContextState => useContext(CmsMapContext);
export const useMyAccount = () =>
	process.env.GATSBY_IS_IE === "true"
		? useContext(MyAccountContextIE)
		: useContext(MyAccountContextUK);

export const useMyAccountUK = (): MyAccountContextStateUK =>
	useContext(MyAccountContextUK);
export const useMyAccountIE = (): MyAccountContextStateIE =>
	useContext(MyAccountContextIE);
